<h1 id="isr-heading" class="display-flex flex-align-center grid-gap-1"><mat-icon aria-label="Interregional Support Requests">support</mat-icon>
    <span class="title font-sans-lg text-bold line-height-sans-1 margin-top-0 margin-bottom-1">INTERREGIONAL SUPPORT REQUESTS - PENDING ({{length}})</span>
</h1>
<table mat-table [dataSource]="reports" class="center" multiTemplateDataRows
       aria-labelledby="isr-heading isr-caption">
    <caption id="isr-caption" class="usa-sr-only">
      Interregional Support Requests - Pending ({{ length }}). Columns: Fire/Complex or Report Name,
      Region, Request Status, Type of Support Requested, Skill(s) Requested, Additional Details, Actions.
    </caption>
    <ng-container matColumnDef="baer_name">
        <th mat-header-cell *matHeaderCellDef>Fire/Complex or Report Name</th>
        <td mat-cell *matCellDef="let support">
            @if (support.assessment) {
            {{support.assessment.baer_name}}
            } @else if (support.report?.baer_name) {
            {{support.report.baer_name + " (" + support.report.report_num + ")"}}
            } @else {
            --
            }
        </td>
    </ng-container>

    <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef>Region</th>
        <td mat-cell *matCellDef="let support" class="prewrap">
            {{( support.assessment?.region || support.report?.region || "--") | line_break}}
        </td>
    </ng-container>


    <ng-container matColumnDef="support_status">
        <th mat-header-cell *matHeaderCellDef>Request Status</th>
        <td mat-cell *matCellDef="let support" class="prewrap">
            @if (support.support_completed) {
            <mat-chip class="chip-4">COMPLETE</mat-chip>
            } @else {
            <mat-chip class="chip-1">PENDING</mat-chip>
            }
        </td>
    </ng-container>



    <ng-container matColumnDef="support_needed_type">
        <th mat-header-cell *matHeaderCellDef>Type of Support Requested</th>
        <td mat-cell *matCellDef="let support">
            @if (support.support_type) {
            <mat-chip>{{ support.support_type }}</mat-chip>
            } @else {
            <span>--</span>
            }
        </td>
    </ng-container>

    <ng-container matColumnDef="support_skills">
        <th mat-header-cell *matHeaderCellDef style="width: 250px">Skill(s) Requested</th>
        <td mat-cell *matCellDef="let support">

            @if (support.main_skill) {
            <mat-chip>{{ support.main_skill | skills }}</mat-chip>
            <mat-chip *ngIf="support.other_skill_count" class="other-skills" [matTooltip]='support.support_skills'
                matTooltipClass="tooltipClass">+{{ support.other_skill_count }}</mat-chip>
            } @else {
            <span>--</span>
            }
        </td>
    </ng-container>

    <ng-container matColumnDef="support_details">
        <th mat-header-cell *matHeaderCellDef>Additional Details</th>
        <td mat-cell *matCellDef="let support">
            <span>{{ support.additional_details || "--" }}</span>
        </td>
    </ng-container>
    <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef style="width: 270px;">Actions</th>
            <td mat-cell *matCellDef="let support" style="width: 270px;">
                <div class="action-div">
                    @if (support.support_type == "Team Lead") {
                        <button class="first-action"
                            (click)="editBaerTeamNeeds(support); stopPropagation($event)">
                            <fa-icon class="fa-sm" [icon]="faEdit"></fa-icon>Identify Team Lead
                        </button>
                        <button class="menu-btn" [matMenuTriggerFor]="menu" aria-label="Individual assessment action list"
                            #t="matMenuTrigger" (click)="stopPropagation($event)" class="{{t.menuOpen ? 'menuOpen' : ''}}">
                            @if (t.menuOpen) {
                            <mat-icon>keyboard_arrow_up</mat-icon>
                            } @else {
                            <mat-icon>keyboard_arrow_down</mat-icon>
                            }
                        </button>
                        <mat-menu #menu="matMenu" class="action-menu" yPosition="below">
                            <button mat-menu-item [routerLink]="'/fire-overview'" [queryParams]="{assessment_id: support.assessment_id || support.report?.assessment_id, tab:1, report_num: support.report?.report_num}">
                                <fa-icon class="fa-sm" [icon]="faUsers"></fa-icon>
                                <span>View Team Roster</span>
                            </button>
                        </mat-menu>
                    } @else {
                        <button class="btn-only" [routerLink]="'/fire-overview'" [queryParams]="{assessment_id: support.assessment_id || support.report?.assessment_id, tab:1, report_num: support.report?.report_num}">
                            <fa-icon class="fa-sm" [icon]="faUsers"></fa-icon>View Team Roster
                        </button>
                    }
                </div>
            </td>
        </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="7">
            <div class="no-data">
                <div class="no-data-icon">
                    <mat-icon class="no-data-icon1">search</mat-icon>
                    <fa-icon [icon]="faUsers" class="no-data-icon2"></fa-icon>
                </div>
                <div class="no-data-title">No Requests</div>
                <p>There are no Requests to review at this time</p>
            </div>
        </td>
    </tr>
</table>

<button aria-label="View All" class="usa-button usa-button--secondary view-all" [routerLink]="'/assessments'" fragment="requests">View All<fa-icon
        [icon]="faChevronRight" aria-label="View All"></fa-icon></button>
